import React from 'react'
import styled from 'styled-components'
import { path } from 'ramda'
import { Colors } from 'advenio-components'

const StatusBarColor = {
  Inactive: '#E2E8EC',
  "Nurse's Room": '#D0021B',
  Home: '#4A4A4A',
  Advenio: Colors.green500,
}

const StatusText = {
  Inactive: 'Este alumno se encuentra ausente',
  "Nurse's Room": 'En Sintomas',
  Home: 'Regresó a casa',
  Advenio: 'En Sala'
}

const StatusIconPath = {
  Inactive: '',
  "Nurse's Room": '/assets/symptom_icon.svg',
  Home: '/assets/home_icon.svg',
  Advenio: '/assets/checkRoom.svg',
}

const StatusBarTextColor = {
  Inactive: '#424242',
  "Nurse's Room": 'white',
  Home: 'white',
  Advenio: 'white',
}

const Bar = styled.div`
  display: ${props => props.status === 'checkIn' ? 'none' : 'flex'};
  background-color: ${props => StatusBarColor[props.status]};
  color:${props => StatusBarTextColor[props.status]};
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 8px 0 8px 0;
  font-size: 12px;
`

const StatusIcon = styled.img`
  margin: 0 4px 0 4px;
`
const CloudBar = styled.div`
  display: ${props => props.isCloud ? 'flex' : 'none'};
  background-color: #f0f9fe;
  color:#4A4A4A;
  justify-content: center;
  align-items: center;
  padding: 8px;
  font-size: 12px;
`

const CloudIcon = styled.img`
  margin: 0 4px 0 4px;
`


const StatusBar = (props) => {
  const { student, isCloud } = props
  return isCloud ? (
    <CloudBar isCloud={student.checkin ? student.checkin.is_virtual_center : false}>
      <CloudIcon src="/assets/cloud_blue.svg" />
      <span>
        {student.first_name} nos visita desde {student.center && student.center.name}
      </span>
    </CloudBar>
  ) :
    (
      <Bar status={path(['checkin', 'status'], student) ? student.checkin.status : 'Inactive'}>
        <StatusIcon src={path(['checkin', 'status'], student) ? StatusIconPath[student.checkin.status] : StatusIconPath.Inactive} />
        <i>{path(['checkin', 'status'], student) ? StatusText[student.checkin.status] : StatusIconPath.Inactive}</i>
      </Bar>
    )
}

export default StatusBar



// WEBPACK FOOTER //
// ./src/Components/ProfilePanel/StatusBar.jsx